<script>
import { mapActions } from 'vuex';
import cookie from 'cookie-machine';
import { mapState } from 'vuex';

export default {
  name: 'MainToolbar',
  data() {
    return {
      languages: ['en', 'tr'], // Desteklenen diller
    };
  },

  methods: {
    ...mapActions('app', ['toggleDrawer']),
    logout() {
      cookie.remove('token');
      cookie.remove('roleIds');
      cookie.remove('user');
      this.$router.push({ path: '/login' });
    },
    onLanguageChange(newLocale) {
      // Dil değiştirildiğinde `$changeLanguage` fonksiyonunu çağır
      this.$changeLanguage(newLocale);

      // Gerekirse dil bilgisini backend'e kaydedebilirsiniz (opsiyonel)
      this.saveUserLanguage(newLocale);
    },
    async saveUserLanguage(locale) {
      try {
        localStorage.setItem('language', locale);
        // await this.$axios.post('/user/updateLanguage', { preferredLanguage: locale });
      } catch (err) {
      }
    },
  },
  computed: {
    ...mapState('app'),
    ...mapState({
      isKysUser: state => state.isKysUser,
    })
  },
  created() {
    // Kullanıcının login olduktan sonra dil bilgisi Vuex'te saklanmışsa:
    
    /*const userLanguage = this.$store.state.user?.preferredLanguage || localStorage.getItem('language');

    // Eğer kullanıcı dil bilgisi varsa, uygulama dilini ayarla
    if (userLanguage) {
      this.$changeLanguage(userLanguage);
    }
    */
     
  },



};
</script>

<template>
  <v-app-bar
    color="white"
    dense
    app
    fixed
    clipped-left
    flat
  >
    <v-app-bar-nav-icon @click.stop="toggleDrawer" />

    <v-toolbar-title color="black">
      <img style="height: 80px; width: auto; margin-left: -20px; margin-top: 10px;" :src="require('@/assets/summa.logo.png')"/>
    </v-toolbar-title>

    <div class="flex-grow-1" />

    <!-- Dil Seçicisi -->
    <v-select
        v-model="$i18n.locale" 
        :items="languages" 
        label="Dil Seç" 
        @change="onLanguageChange" 
        dense
        outlined
        style="max-width: 75px;"
        v-if="isKysUser"
    />

    <v-btn @click="logout" text light small>
      <v-icon small>
        mdi-logout
      </v-icon> Çıkış Yap
    </v-btn>
  </v-app-bar>
</template>
